import { render, staticRenderFns } from "./ModalTags.vue?vue&type=template&id=40ccfb67&scoped=true&"
import script from "./ModalTags.vue?vue&type=script&lang=js&"
export * from "./ModalTags.vue?vue&type=script&lang=js&"
import style0 from "./ModalTags.vue?vue&type=style&index=0&id=40ccfb67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ccfb67",
  null
  
)

export default component.exports